export default __webpack_public_path__ + "static/media/1_1_3.17971595.png";